import React from 'react';
import { Link } from "react-router-dom";
import About1 from '../Images/about-1.jpg'
import About2 from '../Images/about-2.jpg'
import { FaBullseye } from 'react-icons/fa';

const MissionSection = () => (
    <div className="container-fluid py-5 ">
        <div className="container ">
            <div className="row g-5 align-items-center">
                {/* Left Side Images */}
                <div className="col-lg-5 col-md-6 col-sm-12">
                    <div className="h-100 position-relative">
                        <img
                            src={About2}
                            className="img-fluid w-75 rounded shadow"
                            alt="Mission Visual 1"
                            style={{ marginBottom: '25%' }}
                        />
                        <div className="position-absolute w-75" style={{ top: '25%', left: '25%' }}>
                            <img
                                src={About1}
                                className="img-fluid w-100 rounded shadow"
                                alt="Mission Visual 2"
                            />
                        </div>
                    </div>
                </div>

                {/* Right Side Content */}
                <div className="col-lg-7 col-md-6 col-sm-12">
                    <p className="d-inline-block border rounded fw-semibold py-1 px-3 text-navyblue">
                        <FaBullseye className='me-2' /> Our Mission
                    </p>
                    <h2 className="mb-4 fw-bold">Driving Digital Success Through Innovation & Integrity</h2>
                    <p className="text-muted fs-5">
                        Our mission is to empower businesses by delivering cutting-edge IT solutions, proactive
                        cybersecurity strategies, and dependable managed services that ensure stability, growth,
                        and resilience in today’s fast-evolving digital world.
                    </p>
                    <p className="text-muted fs-5">
                        We believe in innovation, transparency, and collaboration. By aligning our solutions with
                        your strategic goals, we transform technology from a challenge into a competitive advantage.
                        At the heart of everything we do is a commitment to trust, excellence, and measurable impact.
                    </p>
                    <Link to="/contact" className="btn-custom rounded-pill px-3 py-2 text-white">
                        Contact Us
                    </Link>
                </div>
            </div>
        </div>
    </div>
);

export default MissionSection;
